import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import {
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
  Grid,
  Divider,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { featureStyle } from "./styles";
import Loading from "../../../loading";
import LabelForm from "../../../../partials/labelForm";

class Feature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listFeature: [],
      listFunction: [],
    };
  }

  componentWillMount() {
    this.props.onRef(null);
  }

  async componentDidMount() {
    this.props.onRef(this);
    this.loading.startLoading();
    const { service = {} } = this.props;
    await this.props.serviceFeatureDispatch.getFeatureForRole({
      serviceCode: service.no,
    });
    this.mergeListFeature(
      this.props.featureState,
      this.props.serviceFeatureState
    );
    await this.props.serviceFunctionDispatch.getFunctionForRole({
      serviceCode: service.no,
    });
    this.mergeListFunction(
      this.props.functionState,
      this.props.serviceFunctionState
    );
    this.loading.stopLoading();
  }

  backupValue(type) {
    type === "feature"
      ? this.mergeListFeature(
          this.props.featureState,
          this.props.serviceFeatureState
        )
      : this.mergeListFunction(
          this.props.functionState,
          this.props.serviceFunctionState
        );
  }

  mergeListFeature = (features, serviceFeature) => {
    if (features.length > 0) {
      var listFeature = [];
      features.forEach((feature) => {
        var value = null;
        let check = 0;
        serviceFeature.forEach((serFeature) => {
          if (serFeature.featureCode === feature.code) {
            value = serFeature.featureValue;
            listFeature.push({ code: feature.code, isHave: 1, value: value });
            check = 1;
          }
        });
        if (check === 0)
          listFeature.push({ code: feature.code, isHave: 0, value: null });
      });
      this.setState({ listFeature: listFeature });
    }
  };

  mergeListFunction = (functions, serviceFunctions) => {
    var listFunction = [];
    functions.forEach((eachFunction) => {
      var value = null;
      serviceFunctions.forEach((serFunction) => {
        if (serFunction.functionCode === eachFunction.code) {
          value = 1;
        }
      });
      if (value !== null) {
        listFunction.push({ code: eachFunction.code, isHave: 1 });
      } else {
        listFunction.push({ code: eachFunction.code, isHave: 0 });
      }
    });
    this.setState({ listFunction: listFunction });
  };

  handleChangeFeature = (name) => (event) => {
    var listFeature = this.state.listFeature;
    var index = listFeature.indexOf(name);
    if (event.target.type === "checkbox") {
      listFeature[index].isHave = listFeature[index].isHave === 1 ? 0 : 1;
    } else {
      listFeature[index].value = event.target.value;
    }
    this.setState({ listFeature });
  };

  handleChangeFunction = (name) => (event) => {
    var listFunction = this.state.listFunction;
    var index = listFunction.indexOf(name);
    listFunction[index].isHave = listFunction[index].isHave === 1 ? 0 : 1;
    this.setState({ listFunction });
  };

  render() {
    const { classes, t, disabled = false } = this.props;
    const { listFeature, listFunction } = this.state;
    return (
      <div className={classes.root}>
        <Loading onRef={(id) => (this.loading = id)} />
        <div className={classes.container}>
          <LabelForm
            label={t("service_ownerspa_servicedetail_feature_feature")}
          />
          <Divider className={classes.divider} />
          <Grid container spacing={3}>
            {listFeature.map((feature, index) => {
              if (feature.code !== "space" && feature.code !== "color") {
                return (
                  <Grid item xs={12} sm={6} key={index}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={disabled}
                          checked={feature.isHave === 1}
                          onChange={this.handleChangeFeature(feature)}
                          color="primary"
                        />
                      }
                      className={classes.inputLabel}
                      label={
                        <Typography className={classes.inputLabel}>
                          {t(feature.code)}
                        </Typography>
                      }
                    />
                  </Grid>
                );
              }
              return "";
            })}
            {listFeature.map((feature, index) => {
              if (feature.code === "space") {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    key={index}
                    direction="column"
                    container={true}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={disabled}
                          checked={feature.isHave === 1}
                          onChange={this.handleChangeFeature(feature)}
                          color="primary"
                        />
                      }
                      className={classes.inputLabel}
                      label={
                        <Typography className={classes.inputLabel}>
                          {t(feature.code)}
                        </Typography>
                      }
                    />
                    <TextField
                      id="space"
                      name="space"
                      style={{ width: "50%" }}
                      fullWidth={false}
                      // margin="normal"
                      disabled={disabled || feature.isHave === 0}
                      value={feature.value === null ? "" : feature.value}
                      onChange={this.handleChangeFeature(feature)}
                      helperText={
                        <span className={classes.helperText}>
                          {t(
                            "service_ownerspa_servicedetail_feature_type_size_your_spa_area"
                          )}{" "}
                        </span>
                      }
                    />
                  </Grid>
                );
              } else if (feature.code === "color") {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    key={index}
                    direction="column"
                    container={true}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={disabled}
                          checked={feature.isHave === 1}
                          onChange={this.handleChangeFeature(feature)}
                          color="primary"
                        />
                      }
                      label={
                        <Typography className={classes.inputLabel}>
                          {t(feature.code)}
                        </Typography>
                      }
                      className={classes.inputLabel}
                    />
                    <TextField
                      id="color"
                      name="color"
                      style={{ width: "50%" }}
                      fullWidth={false}
                      // margin="normal"
                      disabled={disabled || feature.isHave === 0}
                      value={feature.value === null ? "" : feature.value}
                      onChange={this.handleChangeFeature(feature)}
                      helperText={
                        <span className={classes.helperText}>
                          {t(
                            "service_ownerspa_servicedetail_feature_type_color_for_your_spa"
                          )}
                        </span>
                      }
                    />
                  </Grid>
                );
              }
              return "";
            })}
          </Grid>
          <Divider className={classes.divider} />
          <div className={classes.boxButton}>
            <Button
              disabled={disabled}
              onClick={() => this.props.handleUpdate("feature", listFeature)}
              color="primary"
              variant="contained"
              component="span"
              className={classes.button}
            >
              {t("service_ownerspa_servicedetail_update")}
            </Button>
          </div>
        </div>
        <div className={classes.container}>
          <LabelForm
            label={t("service_ownerspa_servicedetail_feature_function")}
          />
          <Divider className={classes.divider} />
          <Grid container spacing={3}>
            {listFunction.map((eachFunction, index) => {
              return (
                <Grid item xs={12} sm={6} key={index}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={disabled}
                        checked={eachFunction.isHave === 1}
                        onChange={this.handleChangeFunction(eachFunction)}
                        color="primary"
                      />
                    }
                    className={classes.inputLabel}
                    label={
                      <Typography className={classes.inputLabel}>
                        {t(eachFunction.code)}
                      </Typography>
                    }
                  />
                </Grid>
              );
            })}
          </Grid>
          <Divider className={classes.divider} />
          <div className={classes.boxButton}>
            <Button
              disabled={disabled}
              onClick={() => this.props.handleUpdate("function", listFunction)}
              color="primary"
              variant="contained"
              component="span"
              className={classes.button}
            >
              {" "}
              {t("service_ownerspa_servicedetail_update")}{" "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

Feature.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  featureState: state.serviceFeature.feature,
  functionState: state.serviceFunction.functions,
  serviceFeatureState: state.serviceFeature.serviceFeature,
  serviceFunctionState: state.serviceFunction.serviceFunctions,
  role: state.user.user.roleId.role,
  ownerCode: state.service.service.userCode,
});

const mapDispatch = (dispatch) => ({
  serviceFeatureDispatch: dispatch.serviceFeature,
  serviceFunctionDispatch: dispatch.serviceFunction,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(featureStyle, { withTheme: true })(Feature)
  )
);
